export const regionsImg = [
  { id: 1, src: '/img/seoul.jpg', alt: '서울' },
  { id: 2, src: '/img/daejeon.jpg', alt: '대전' },
  { id: 3, src: '/img/daegu.jpg', alt: '대구' },
  { id: 4, src: '/img/busan.jpg', alt: '부산' },
  { id: 5, src: '/img/gwangju.jpg', alt: '광주' },
  { id: 6, src: '/img/gangwondo.jpg', alt: '강원도' },
  { id: 7, src: '/img/incheon.jpg', alt: '인천' },
  { id: 8, src: '/img/jeju.jpg', alt: '제주' },
  { id: 9, src: '/img/jeonju.jpg', alt: '전주' },
  { id: 10, src: '/img/suncheon.jpg', alt: '순천' },
  { id: 11, src: '/img/incheon.jpg', alt: '독도' },
];

export const categoriesImg = [
  { id: 1, src: '/img/korean-food.jpg', alt: '한식' },
  { id: 2, src: '/img/chinese-food.jpg', alt: '중식' },
  { id: 3, src: '/img/japanese-food.jpg', alt: '일식' },
  { id: 4, src: '/img/pasta.jpg', alt: '양식' },
  { id: 5, src: '/img/tteokbokki.jpg', alt: '분식' },
  { id: 6, src: '/img/snack.jpg', alt: '과자' },
  { id: 7, src: '/img/chicken.jpg', alt: '치킨' },
  { id: 8, src: '/img/defaultImg.png', alt: '테스트' },
  { id: 9, src: '/img/drink.jpg', alt: '음료' },
  { id: 10, src: '/img/candy.jpg', alt: '사탕' },
  { id: 11, src: '/img/defaultImg.png', alt: 'qq' },
];
